var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoBulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 37,
    viewBox: "0 0 38 37",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.32031 6.82007L8.29364 7.79339",
    stroke: "#424A63",
    strokeWidth: 3.96429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 1.98218L19 3.35867",
    stroke: "#424A63",
    strokeWidth: 3.96429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5176 18.5L34.1411 18.5",
    stroke: "#424A63",
    strokeWidth: 3.96429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.85938 18.5L2.48289 18.5",
    stroke: "#424A63",
    strokeWidth: 3.96429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6797 6.82007L29.7064 7.79339",
    stroke: "#424A63",
    strokeWidth: 3.96429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8469 19.1073C27.8578 17.5283 27.4458 15.9751 26.6538 14.609C25.8617 13.2429 24.7184 12.1137 23.3426 11.3387C21.9668 10.5636 20.4086 10.171 18.8298 10.2015C17.251 10.232 15.7092 10.6845 14.3643 11.5121C13.0195 12.3397 11.9207 13.5122 11.182 14.9079C10.4433 16.3035 10.0916 17.8715 10.1635 19.4489C10.2354 21.0264 10.7282 22.5559 11.5907 23.8785C13.1311 26.2405 14.043 27.1088 14.043 29.9196C14.043 30.1803 14.1466 30.4303 14.3309 30.6146C14.5152 30.799 14.7652 30.9025 15.0259 30.9025H22.975C23.2357 30.9025 23.4858 30.799 23.6701 30.6146C23.8544 30.4303 23.958 30.1803 23.958 29.9196C23.958 27.041 24.9781 26.1865 26.5083 23.7383C27.3765 22.3491 27.84 20.7454 27.8469 19.1073Z",
    fill: "#1D202B",
    stroke: "#424A63",
    strokeWidth: 3.96429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4688 30.9026H22.5326V33.4681C22.5326 35.4187 20.9513 37 19.0007 37C17.0501 37 15.4688 35.4187 15.4688 33.4681V30.9026Z",
    fill: "#424A63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoBulb);
export default __webpack_public_path__ + "static/media/info-bulb.3601116d6ecc195185d23753b2ec91bc.svg";
export { ForwardRef as ReactComponent };